/**
 * AuthApiClient -- HTTP client for /api/Auth.
 *
 * @module infrastructure/api/AuthApiClient
 */

import { AppConfig } from '../../config.js';
import { ok, fail } from '../../domain/value-objects/CrudResult.js';

const BASE = '/api/Auth';

export const AuthApiClient = {
  async login(email, password) {
    try {
      const res = await fetch(`${AppConfig.apiBase}${BASE}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        return fail(res.status, data?.mensaje || data?.detail || `Error ${res.status}`);
      }
      return ok(data);
    } catch (e) {
      return fail('NETWORK', e.message);
    }
  },

  async validate() {
    if (!AppConfig.token) return fail('NO_TOKEN', 'Sin token');
    try {
      const res = await fetch(`${AppConfig.apiBase}${BASE}/validate`, {
        headers: { 'Authorization': `Bearer ${AppConfig.token}` }
      });
      if (!res.ok) return fail(res.status, 'Token invalido');
      const data = await res.json().catch(() => ({}));
      return ok(data);
    } catch (e) {
      return fail('NETWORK', e.message);
    }
  },

  async changePassword(currentPassword, newPassword) {
    try {
      const res = await fetch(`${AppConfig.apiBase}${BASE}/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AppConfig.token}`
        },
        body: JSON.stringify({ currentPassword, newPassword })
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) return fail(res.status, data?.mensaje || `Error ${res.status}`);
      return ok(data);
    } catch (e) {
      return fail('NETWORK', e.message);
    }
  }
};
